<template>
  <div class="relatorio-container">
    <div class="relatorio-header">
      <img src="@/assets/logo-2.png" alt="Logo" />
    </div>

    <div class="loading" v-if="!loaded">
      <LoadingSpinner />
    </div>

    <div v-else class="relatorio-body">
      <h1>Relatório de aula prática</h1>

      <div class="actions">
        <Button text="Gerar relatório" color="primary" @handle:click="handleGenerate">
          <FileDocumentMultipleOutline :size="18" />
        </Button>
      </div>

      <div class="box">
        <div class="info-row">
          <div class="info-item">
            <strong>Aluno:</strong>
            <span>{{ aluno.nomeAluno }}</span>
          </div>

          <div class="info-item">
            <strong>Renach:</strong>
            <span>{{ aluno.alunoRenach }}</span>
          </div>

          <div class="info-item">
            <strong>Instrutor:</strong>
            <span>{{ aluno.nomeInstrutor }}</span>
          </div>

          <div class="info-item">
            <strong>Categoria:</strong>
            <span>{{ aluno.categoria_cnh }}</span>
          </div>

          <div class="info-item">
            <strong>Placa:</strong>
            <span>{{ aluno.placa }}</span>
          </div>
        </div>
      </div>

      <div class="box">
        <div class="info-row">
          <div class="info-item">
            <strong>Inicio da Aula (Previsto):</strong>
            <span>{{ utils.formatDate(aluno.data_aula) }}</span>
          </div>

          <div class="info-item">
            <strong>Duração (Previsto):</strong>
            <span>50 Minutos</span>
          </div>

          <div class="info-item">
            <strong>Fim da aula (Previsto):</strong>
            <span>
              {{
                utils.formatDate(
                  aluno.data_aula.split(' ')[0] +
                    ' ' +
                    new Date(
                      new Date(aluno.data_aula).getTime() + aluno.anotacao.qtdAulas * 50 * 60000
                    ).toLocaleTimeString()
                )
              }}</span
            >
          </div>
        </div>

        <div class="info-row">
          <div class="info-item">
            <strong>Inicio da Aula (Real):</strong>
            <span>{{ utils.formatDate(aluno.anotacao.begin_time, false, true) }}</span>
          </div>

          <div class="info-item">
            <strong>Duração (Real):</strong>
            <span>
              {{
                Math.trunc(
                  new Date(
                    new Date(aluno.anotacao.finish_time).getTime() -
                      new Date(aluno.anotacao.begin_time).getTime()
                  ).getTime() / 60000
                )
              }}
              Minutos</span
            >
          </div>

          <div class="info-item">
            <strong>Fim da aula (Real):</strong>
            <span> {{ utils.formatDate(aluno.anotacao.finish_time, false, true) }}</span>
          </div>
        </div>
      </div>

      <div class="box">
        <div class="info-row">
          <div class="info-item">
            <strong>Quilometragem:</strong>
            <span>{{ aluno.anotacao.hodo_start }} Km</span>
          </div>

          <div class="info-item">
            <strong>Quilometragem final:</strong>
            <span>{{ aluno.anotacao.hodo_end }}</span>
          </div>

          <div class="info-item">
            <strong>Distância percorrida (Hodômetro):</strong>
            <span>{{ aluno.anotacao.distancia }} Km</span>
          </div>

          <div class="info-item">
            <strong>Distância percorrida (GPS):</strong>
            <span>{{ distanciaPercorridaGPS }}</span>
          </div>
        </div>
      </div>

      <Tabs :options="['Alertas']">
        <div slot="Alertas">
          <Table :headers="['Instrutor', 'Veículo', 'Data e Hora', 'Alerta']">
            <tr v-if="!alerts.length">
              <td colspan="4">
                <div class="text-center"><span>Sem alertas</span></div>
              </td>
            </tr>
            <tr v-else v-for="alert in alerts" :key="alert.id">
              <td>{{ alert.nomeInstrutor }}</td>
              <td>{{ alert.placa }}</td>
              <td>{{ alert.data_aula | DateBRFilter }}</td>
              <td v-if="alert.alerta_total">{{ alert.alerta }} - <strong>Tempo total parado: {{ alert.alerta_total }}</strong></td>
              <td v-else>{{ alert.alerta }}</td>
            </tr>
          </Table>
        </div>
      </Tabs>

      <Tabs :options="['Trajeto']" class="trajeto">
        <div slot="Trajeto" class="trajeto-container">
          <span>Ajuste o mapa e pressione CTRL-P para imprimir</span>

          <GoogleMap
            v-if="mapAvailable"
            :infractions="aluno.anotacao.infracoes"
            :positions="aluno.anotacao.posicoes"
            :beginTime="aluno.anotacao.begin_time"
          />
        </div>
      </Tabs>

      <span class="footer">© {{ getDateYearActual() }} - FábricaInfo</span>
    </div>
  </div>
</template>
<script>
import Button from 'core/Button'
import LoadingSpinner from 'core/LoadingSpinner'
import Table from 'core/Table'
import Tabs from 'core/Tabs'

import FileDocumentMultipleOutline from 'icons/FileDocumentMultipleOutline'

import GoogleMap from '@/components/google/GoogleMap'
import urlApi from '@/router/urlApiV2'
import utils from '@/services/utils'
import Vue from 'vue'

export default {
  components: {
    Tabs,
    Table,
    LoadingSpinner,
    Button,

    FileDocumentMultipleOutline,

    urlApi,
    GoogleMap,
  },
  data() {
    return {
      utils,
      alerts: [],
      loaded: false,

      aluno: {},
      mapAvailable: false,
      loadingData: true,
    }
  },
  async mounted() {
    await this.loadAula(this.$route.params.autoescola, this.$route.params.aula)
    await this.getAlertaDetails(this.aluno.id_anotacao_pratica)

    this.loaded = true
  },
  computed: {
    distanciaPercorridaGPS() {
      // Função para calcular a distância entre dois pontos usando a fórmula de Haversine
      function haversine(lat1, lon1, lat2, lon2) {
        const toRad = deg => (deg * Math.PI) / 180
        const R = 6371 // Raio da Terra em km
        const dLat = toRad(lat2 - lat1)
        const dLon = toRad(lon2 - lon1)
        const a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(toRad(lat1)) *
            Math.cos(toRad(lat2)) *
            Math.sin(dLon / 2) *
            Math.sin(dLon / 2)
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
        return R * c
      }

      // Verifica se os dados estão disponíveis
      if (!this.aluno || !this.aluno.anotacao || !this.aluno.anotacao.posicoes) {
        return '0.00 km'
      }

      const posicoes = this.aluno.anotacao.posicoes
      
      // Verifica se há pelo menos 2 posições para calcular distância
      if (posicoes.length < 2) {
        return '0.00 km'
      }

      let distancia = 0
      for (let i = 1; i < posicoes.length; i++) {
        const prev = posicoes[i - 1]
        const curr = posicoes[i]
        
        // Valida se as coordenadas são válidas
        if (prev.lat && prev.lon && curr.lat && curr.lon) {
          distancia += haversine(
            parseFloat(prev.lat), 
            parseFloat(prev.lon), 
            parseFloat(curr.lat), 
            parseFloat(curr.lon)
          )
        }
      }
      
      return `${distancia.toFixed(2)} km`
    },
  },
  methods: {
    async loadAula(schema, aulaId) {
      await Vue.http
        .get(
          urlApi +
            '/dashboard/aulas/praticas/realizada/monitoramento?pId=' +
            aulaId +
            '&schema=' +
            schema
        )
        .then(response => {
          if (response.body.sucesso) {
            this.aluno = response.body.data
            if (response.body.data.anotacao.posicoes.length > 0) {
              this.mapAvailable = true
            }
            this.loadingData = false
          } else {
            console.error("Couldn't connect to server")
          }
        })
    },
    async getAlertaDetails(id) {
      this.$http
        .get(
          `${process.env.VUE_APP_URL_API_V2}/aulas/praticas/consultar/alerta/${this.$route.params.autoescola}/${id}`
        )
        .then(({ body }) => {
          this.alerts = body.dados
        })
        .catch(err => {
          this.$toasted.show(err.body.mensagem, {
            icon: 'fa-times',
            position: 'top-right',
            duration: 5000,
            fullWidth: false,
          })
        })
    },
    getDateYearActual() {
      let dt = new Date()
      return dt.getFullYear()
    },
    handleGenerate() {
      window.print()
    },
  },
}
</script>

<style lang="scss" scoped>
.relatorio-container {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  .relatorio-header {
    padding: 2rem;
    background-color: #1b2c5a;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 300px;
    }
  }

  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .relatorio-body {
    margin: 0 auto;
    width: 80vw;

    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    h1 {
      margin: 0;
      font-weight: 600;
      font-size: 2rem;
      color: #1b2c5a;
      text-align: center;
    }

    .actions {
      display: flex;
      justify-content: flex-end;
    }

    .box {
      padding: 1rem;
      border: 1px solid #1b2c5a;
      border-radius: 10px;

      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .info-row {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;

      .info-item {
        flex: 1;
        display: flex;
        flex-direction: column;

        strong {
          font-size: 1.125rem;
          font-weight: 600;
          color: #1b2c5a;
        }

        span {
          font-weight: 400;
        }
      }
    }

    .trajeto-container {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      span {
        font-size: 0.75rem;
        font-weight: 600;
        color: #1b2c5a;
      }
    }

    .footer {
      padding: 1rem 0;
      display: flex;
      align-items: center;
      justify-content: center;

      font-weight: 600;
    }
  }

  @media print {
    .relatorio-header {
      display: none;
    }

    .relatorio-body {
      margin-top: 2rem;

      .actions {
        display: none;
      }

      .trajeto {
        page-break-before: always;

        .trajeto-container {
          span {
            display: none;
          }
        }
      }
    }
  }
}
</style>
